import type { QueryResult } from 'react-apollo';

import { keys as sessionStorageKeys } from '@confluence/storage-manager';

import type {
	FeedPopularFeedQuery as FeedPopularFeedQueryType,
	FeedPopularFeedQueryVariables,
} from './__types__/FeedPopularFeedQuery';
import { PopularFeedTimeGranularityValue } from './Feed';
import { useFeedDropdownStorage } from './useFeedDropdownStorage';
import { FeedPopularFeedQuery } from './FeedPopularFeedQuery.graphql';

export const usePopularFeedWithTimeGranularityStorage = (
	renderPopularFeed: boolean,
): {
	popularFeedTimeGranularity: PopularFeedTimeGranularityValue;
	setPopularFeedTimeGranularity: (timeGranularity: PopularFeedTimeGranularityValue) => void;
	popularFeedQuery: QueryResult<FeedPopularFeedQueryType, FeedPopularFeedQueryVariables>;
} => {
	const { value, setValue, query } = useFeedDropdownStorage<
		FeedPopularFeedQueryType,
		FeedPopularFeedQueryVariables,
		PopularFeedTimeGranularityValue
	>(
		{
			defaultValue: PopularFeedTimeGranularityValue.Default,
			sessionStorageKey: sessionStorageKeys.HOME_POPULAR_FEED_TIME_GRANULARITY,
			skipQuery: !renderPopularFeed,
		},
		{
			query: FeedPopularFeedQuery,
			variables: (
				timeGranularity: PopularFeedTimeGranularityValue,
			): FeedPopularFeedQueryVariables => ({
				timeGranularity,
			}),
		},
	);

	return {
		popularFeedTimeGranularity: value,
		setPopularFeedTimeGranularity: setValue,
		popularFeedQuery: query,
	};
};
